function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import * as _tokens from "./tokens";
import { lightFn, darkFn } from "./tokenFunctions";
export var tokens = _tokens;
var addVersion = process.env.NODE_ENV === 'test' ? undefined : {
    version: tokens.version
};
export var getTheme = function(key) {
    return _objectSpread({}, tokens[key], addVersion);
};
export var getLightThemeFn = function(options) {
    return _objectSpread({}, lightFn(options), addVersion);
};
export var getDarkThemeFn = function(options) {
    return _objectSpread({}, darkFn(options), addVersion);
};
export var getLightTheme = function() {
    return getTheme('default');
};
export var getDefaultTheme = function() {
    return getTheme('default');
};
export var getDarkTheme = function() {
    return getTheme('dark');
};
